import React, { createContext, useContext, useState } from 'react';
import { MainLayoutParamsModel, TimelogStatusResponse } from '../../defs/defs';

interface Cache {
    timelogStatus?: TimelogStatusResponse | null;
    mainLayoutParams?: MainLayoutParamsModel | null;
    // Add more keys as needed
}

interface CacheContextType {
    cache: Cache;
    setCache: (key: keyof Cache, value: any) => void;
}

const CacheContext = createContext<CacheContextType | undefined>(undefined);

export const CacheProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [cache, setCacheState] = useState<Cache>({});

    const setCache = (key: keyof Cache, value: any) => {
        setCacheState(prev => ({ ...prev, [key]: value }));
    };

    return (
        <CacheContext.Provider value={{ cache, setCache }}>
            {children}
        </CacheContext.Provider>
    );
};

export const useCache = () => {
    const ctx = useContext(CacheContext);
    if (!ctx) throw new Error('useCache must be used within CacheProvider');
    return ctx;
}; 